<template>
  <div class="sticker-library">
    <div class="global-header-wrap">
      <div class="global-table-header">
        <div class="header-btn-left">
          <list-search ref="listSearch" @listSearchEvn="listSearchEvn" />
        </div>
        <div class="header-btn-right">
          <button class="global-button-style" @click="toUploadData">
            上传贴纸
          </button>
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <div class="table-main" ref="tableMain">
        <el-table
          :data="formattedTableData"
          border
          size="small"
          style="width: 100%"
          :height="tableHeight"
          :header-cell-style="{ background: '#f7f7f7', fontWeight: 500, textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
        >
          <el-table-column type="index" label="No" width="50" align="center">
            <template slot-scope="scope">
              {{ (params.page - 1) * params.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="id" label="贴纸id" width="100" align="center" show-overflow-tooltip />
          <el-table-column prop="thumbnail" label="缩略图" width="110" align="center">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.thumbnail"
                :src="scope.row.thumbnail"
                fit="fill"
                :preview-src-list="[scope.row.thumbnail]"
                style="width: 80px; height: 60px; border-radius: 4px;"
              />
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="thumbnailBadge" label="缩略图角标" width="110" align="center" show-overflow-tooltip />
          <el-table-column prop="title" label="标题" width="180" align="center" show-overflow-tooltip />
          <el-table-column prop="tags" label="标签" width="200" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.tags && scope.row.tags.length" class="tags-cell">
                <div
                  v-for="(t, tIndex) in scope.row.tags"
                  :key="t && t.id ? t.id : tIndex"
                  class="tag-pill"
                  :title="t && t.name ? t.name : t"
                >
                  {{ t && t.name ? t.name : t }}
                </div>
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="slogan" label="适用设备" width="120" align="center" show-overflow-tooltip />
          <el-table-column prop="realUsageCount" label="真实创建量" width="110" align="center" show-overflow-tooltip />
          <el-table-column prop="publisherName" label="发布人" width="130" align="center" show-overflow-tooltip />
          <el-table-column prop="buttonBadge" label="按钮角标" width="110" align="center" show-overflow-tooltip />
          <el-table-column prop="paymentType" label="资料类型" width="110" align="center" show-overflow-tooltip />
          <el-table-column prop="price" label="原价" width="100" align="center" show-overflow-tooltip />
          <el-table-column prop="price1" label="常规折扣价" width="120" align="center" show-overflow-tooltip />
          <el-table-column prop="price2" label="文星会员折扣价" width="150" align="center" show-overflow-tooltip />
          <el-table-column prop="price3" label="Pro会员折扣价" width="140" align="center" show-overflow-tooltip />
          <el-table-column prop="status" label="状态" width="100" align="center" show-overflow-tooltip />
          <el-table-column label="操作" width="300" align="center" fixed="right">
            <template slot-scope="scope">
              <span class="checkDetailsBtn" @click="onRowAction('编辑', scope.row)">编辑</span>
              <span
                :class="getStatusBtnClass(scope.row.statusCode)"
                @click="onRowAction('状态', scope.row)"
              >{{ scope.row.statusBtnText }}</span>
              <span class="checkDetailsBtn" @click="onRowAction('测试', scope.row)">测试</span>
              <span class="checkDetailsBtn" @click="onRowAction('复制链接', scope.row)">复制链接</span>
              <span class="checkDetailsBtn" @click="onRowAction('操作详情', scope.row)">操作详情</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrapper">
        <pagination :currentPage="params.page" :pageSize="params.pageSize" :total="total" @pageNum="getPageNum" />
      </div>
    </div>

    <!-- 上传/编辑贴纸对话框 -->
    <el-dialog :title="detailId ? '编辑贴纸' : '上传贴纸'" :visible.sync="uploadVisible" width="90%" fullscreen
      :close-on-click-modal="false">
      <upload-data :detailId="detailId" @success="handleUploadSuccess" />
    </el-dialog>

    <!-- 操作详情对话框 -->
    <el-dialog title="操作详情" :visible.sync="optRecordVisible" width="90%" fullscreen>
      <opt-record :detailId="detailId" />
    </el-dialog>

    <!-- 测试对话框 -->
    <el-dialog title="测试" :visible.sync="testVisible" width="500px">
      <test @confirm="testConfirm" @close="testVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import listSearch from "@/components/listSearch";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
import UploadData from "./components/uploadData/index.vue";
import OptRecord from "./components/optRecord/index.vue";
import Test from "@/components/Test.vue";
import api from "@/api";
import { valueByLanguage } from "@/utils/college";

const ShelfStatusEnum = {
  NOT_LISTED: 0,
  LISTED: 1,
  REMOVED: 2,
  PERMANENTLY_REMOVED: 3
};

const ShelfStatusMap = {
  0: "待上架",
  1: "已上架",
  2: "已下架",
  3: "已彻底下架"
};

const PaymentTypeMap = {
  FREE: "免费",
  PREMIUM: "付费",
  VIP_PRO: "Pro会员领取"
};

export default {
  name: "StickerLibrary",
  components: {
    listSearch,
    pagination,
    UploadData,
    OptRecord,
    Test
  },
  mixins: [listMixin],
  data() {
    return {
      tableHeight: 400,
      params: {
        page: 1,
        pageSize: 20
      },
      tableData: [],
      total: 0,
      uploadVisible: false,
      optRecordVisible: false,
      testVisible: false,
      detailId: null
    };
  },
  computed: {
    formattedTableData() {
      return this.tableData.map((row) => {
        const thumbnail = valueByLanguage(row.thumbnail, "zh_CN", true);
        const thumbnailBadge = valueByLanguage(row.thumbnailBadge, "zh_CN", true);
        const title = valueByLanguage(row.title, "zh_CN", true);
        const slogan = valueByLanguage(row.slogan, "zh_CN", true);
        const buttonBadge = valueByLanguage(row.buttonBadge, "zh_CN", true);
        const publisherName = row.publisher
          ? valueByLanguage(row.publisher.name, "zh_CN", true) || row.publisher.name || "-"
          : "-";

        const tags = Array.isArray(row.tags)
          ? row.tags
            .map((tag) => {
              if (!tag) return null;
              const rawName = (() => {
                if (!tag.name) return "";
                if (Array.isArray(tag.name)) {
                  return valueByLanguage(tag.name, "zh_CN", true) || "";
                }
                return String(tag.name || "");
              })();
              if (!rawName || !rawName.trim()) return null;
              return {
                ...tag,
                name: rawName
              };
            })
            .filter((t) => t !== null)
          : [];

        const statusBtnMap = {
          0: "上架",
          1: "下架",
          2: "彻底下架",
          3: "已彻底下架"
        };

        const paymentInfo = row.paymentInfo || {};
        const paymentType = paymentInfo.type;

        return {
          ...row,
          thumbnail: thumbnail || "",
          thumbnailBadge: thumbnailBadge || "-",
          title: title || "-",
          tags,
          slogan: slogan || "-",
          publisherName,
          buttonBadge: buttonBadge || "-",
          paymentType: PaymentTypeMap[paymentType] || "-",
          price:
            paymentInfo.price !== null && paymentInfo.price !== undefined
              ? (paymentInfo.price / 100).toFixed(2)
              : "-",
          price1:
            paymentInfo.price1 !== null && paymentInfo.price1 !== undefined
              ? (paymentInfo.price1 / 100).toFixed(2)
              : "-",
          price2:
            paymentInfo.price2 !== null && paymentInfo.price2 !== undefined
              ? (paymentInfo.price2 / 100).toFixed(2)
              : "-",
          price3:
            paymentInfo.price3 !== null && paymentInfo.price3 !== undefined
              ? (paymentInfo.price3 / 100).toFixed(2)
              : "-",
          status: ShelfStatusMap[row.status] || "未知",
          statusCode: row.status,
          statusBtnText: statusBtnMap[row.status] || "状态"
        };
      });
    }
  },
  mounted() {
    this.updateTableHeight();
    window.addEventListener("resize", this.updateTableHeight);
    this.getList();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableHeight);
  },
  methods: {
    updateTableHeight() {
      this.$nextTick(() => {
        const el = this.$refs.tableMain;
        if (el && el.clientHeight) {
          this.tableHeight = el.clientHeight;
        }
      });
    },
    getList() {
      api
        .getStickerList(this.params)
        .then((res) => {
          this.tableData = res.data.items || [];
          this.total = res.data.count || 0;
          this.updateTableHeight();
        })
        .catch((err) => {
          this.$message.error(err.message || "获取列表失败");
        });
    },
    listSearchEvn(values) {
      this.params = {
        page: 1,
        pageSize: 20,
        text: values
      };
      this.getList();
    },
    getPageNum(page) {
      this.params.page = page;
      this.getList();
    },
    getStatusBtnClass(status) {
      const statusColorMap = {
        0: "checkDetailsBtn success-btn",
        1: "checkDetailsBtn danger-btn",
        2: "checkDetailsBtn danger-btn",
        3: "checkDetailsBtn info-btn"
      };
      return statusColorMap[status] || "checkDetailsBtn";
    },
    onRowAction(type, row) {
      this.tableHandle({ type, data: { row } });
    },
    tableHandle(data) {
      const row = data.data && data.data.row ? data.data.row : data.row;

      if (!row || !row.id) return;
      const originalItem = this.tableData.find((item) => item && item.id === row.id);
      if (!originalItem) return;

      if (data.type === "编辑") {
        this.toUploadData(originalItem);
      } else if (data.type === "状态") {
        this.updateShelfStatus(originalItem);
      } else if (data.type === "测试") {
        this.openTest(originalItem);
      } else if (data.type === "复制链接") {
        this.copyLink(originalItem);
      } else if (data.type === "操作详情") {
        this.openOptRecord(originalItem);
      }
    },
    toUploadData(row) {
      this.detailId = row ? row.id : null;
      this.uploadVisible = true;
    },
    updateShelfStatus(row) {
      if (row.status === ShelfStatusEnum.PERMANENTLY_REMOVED) {
        this.$message.warning("已彻底下架，无法操作");
        return;
      }
      const newStatus = row.status + 1;
      api
        .updateStickerStatus(row.id, { status: newStatus })
        .then(() => {
          this.$message.success("操作成功");
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err.message || "操作失败");
        });
    },
    openOptRecord(row) {
      this.detailId = row.id;
      this.optRecordVisible = true;
    },
    copyLink(row) {
      try {
        const url = `${window.location.origin}/library/material/detail?id=${row.uniqueId}&lang=zh&type=STICKER`;
        const textarea = document.createElement("textarea");
        textarea.value = url;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.$message.success("复制成功，请在浏览器粘贴");
      } catch (err) {
        this.$message.error("复制失败");
      }
    },
    openTest(row) {
      this.detailId = row.id;
      this.testVisible = true;
    },
    testConfirm(data) {
      api
        .testSticker(this.detailId, data)
        .then(() => {
          this.$message.success("测试成功");
          this.testVisible = false;
        })
        .catch((err) => {
          this.$message.error(err.message || "测试失败");
        });
    },
    handleUploadSuccess() {
      this.uploadVisible = false;
      this.detailId = null;
      this.getList();
    }
  }
};
</script>

<style scoped>
.sticker-library {
  height: 100%;
  min-width: 0;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.global-header-wrap {
  flex-shrink: 0;
  padding: 0 20px;
}

.table-wrapper {
  flex: 1;
  min-height: 0;
  min-width: 0;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-main {
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.table-main :deep(.el-table__body-wrapper) {
  scrollbar-width: thin;
  scrollbar-color: #909399 #e4e7ed;
}

.table-main :deep(.el-table__body-wrapper)::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.table-main :deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb {
  background: #909399;
  border-radius: 5px;
}

.table-main :deep(.el-table__body-wrapper)::-webkit-scrollbar-track {
  background: #e4e7ed;
}

.tags-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
  width: 100%;
  overflow: hidden;
}

.tag-pill {
  color: #67c23a;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  padding: 0 6px;
  max-width: 85px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}

.success-btn {
  color: #67c23a !important;
}

.danger-btn {
  color: #f56c6c !important;
}

.info-btn {
  color: #909399 !important;
}

.pagination-wrapper {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
